import React from 'react'
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  CircularProgress,
  Icon,
  Tooltip,
} from '@mui/material'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { SelectInput, TextInput } from '../../../../ui'
import { REQUIRE_NUMBER } from '../../constants'
import { useConsultContext } from '../../contexts'

export const NormalizeForm = ({
  formState,
  onChange,
  fieldList,
  isLoadingPotencia,
  isLoadingConsumo,
  debounceTimer = null,
}) => {
  const cases = useSelector((state) => state.combos.uso_punto_suministro?.data)
  const { customerForm } = useConsultContext()
  const { formatMessage } = useIntl()

  const isSpecial = ['pymes', 'gran_consumo', 'caldera_centralizada'].includes(formState.uso)

  return (
    <Box mb={2}>
      <FormControl component="fieldset" onChange={onChange}>
        Uso (*):{' '}
        <RadioGroup row value={formState.uso}>
          {cases?.map(({ key, value }) => (
            <FormControlLabel
              key={key}
              value={key}
              checked={customerForm.uso === key}
              name="uso"
              control={<Radio size="small" color="primary" />}
              label={
                <Typography variant="body1" color="textSecondary">
                  {value}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
      {REQUIRE_NUMBER.includes(formState.uso) && (
        <Grid size={{ xs: 12 }}>
          <Box
            display="flex"
            alignItems="center"
            mb={1}
            width="20em"
            justifyContent="space-between"
          >
            <Box mr={2}>
              <Typography variant="subtitle1">Potencia</Typography>
            </Box>
            {isLoadingPotencia && <CircularProgress size={16} color="primary" />}
            <Box alignSelf="flex-end" width={200} position="relative">
              <div style={{ display: isSpecial ? 'none' : 'block' }}>
                <SelectInput
                  {...fieldList['POTENCIA']}
                  name="potencia"
                  value={formState.potencia || ''}
                  onChange={onChange}
                  disabled={isSpecial}
                  required={!isSpecial}
                />
              </div>
              <div style={{ display: isSpecial ? 'block' : 'none' }}>
                <TextInput
                  name="potenciaNumeric"
                  type="number"
                  value={formState.potenciaNumeric || ''}
                  onChange={onChange}
                  inputProps={{
                    min: 0,
                    step: 1,
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                  placeholder="Potencia (kW)"
                  size="small"
                  margin="dense"
                />
              </div>
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            mb={1}
            width="20em"
            justifyContent="space-between"
          >
            <Box mr={2} display="flex" alignItems="center">
              <Typography variant="subtitle1">Consumo</Typography>
              <Tooltip
                title={
                  <span style={{ fontWeight: 'bold', fontSize: 12 }} data-role="size info">
                    {formatMessage({ id: 'pages.consult.tooltip.tooltip_potencia' })}
                  </span>
                }
              >
                <span style={{ fontSize: 16, marginLeft: 4 }} data-role="upload help label">
                  <Icon fontSize="inherit">help_outline</Icon>
                </span>
              </Tooltip>
              {isLoadingConsumo && (
                <Box ml={1}>
                  <CircularProgress size={16} color="primary" />
                </Box>
              )}
            </Box>
            <Box alignSelf="flex-end" width={200}>
              <SelectInput
                {...fieldList['CONSUMO']}
                disabled={
                  !formState.potencia ||
                  debounceTimer !== null ||
                  isLoadingConsumo ||
                  isLoadingPotencia
                }
              />
            </Box>
          </Box>
        </Grid>
      )}
    </Box>
  )
}

export default NormalizeForm
